module.exports = __webpack_public_path__ + "static/img/footer-logo.3905462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo.png
// module id = DSQX
// module chunks = 0